import { channelCreateReducer } from '@shared/scenes/channel/create/store/reducer';
import { channelDetailsFormReducer } from '@shared/scenes/channel/detailsForm/store/reducer';
import { chatInputReducer } from '@shared/scenes/chat/input/store/reducer';
import { notifyPendingUsersReducer } from '@shared/scenes/chat/notifyPendingUsers/store/reducer';
import { chatMessagesReducer } from '@shared/scenes/chat/thread/store/reducer';
import { gifsReducer } from '@shared/scenes/gifs/store/reducer';
import { uploadReducer } from '@shared/scenes/upload/store/reducer';
import { sentryListenerReducer } from '@shared/util/sentry';
import { appStateReducer } from './appState/reducer';
import { linkDataReducer } from './linkData/reducer';

export const reducers = {
  channelCreate: channelCreateReducer,
  channelDetailsForm: channelDetailsFormReducer,
  chatMessages: chatMessagesReducer,
  chatInput: chatInputReducer,
  linkData: linkDataReducer,
  gifs: gifsReducer,
  upload: uploadReducer,
  notifyPendingUsers: notifyPendingUsersReducer,
  sentryListener: sentryListenerReducer,
  appState: appStateReducer,
};
